import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { UI } from "./translations";
import { UI_GENERATED } from "./uiGenerated";
import { LANG_CODES, getLanguage } from "./languages";

const LanguageContext = createContext(null);

const TABLES = { ...UI_GENERATED, ...UI };

function detectInitial() {
  const params = new URLSearchParams(window.location.search);
  const q = params.get("lang");
  if (q && LANG_CODES.includes(q)) return q;
  const stored = localStorage.getItem("tt_lang");
  if (stored && LANG_CODES.includes(stored)) return stored;
  const nav = (navigator.language || "en").slice(0, 2);
  return LANG_CODES.includes(nav) ? nav : "en";
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detectInitial);

  useEffect(() => {
    localStorage.setItem("tt_lang", lang);
    const meta = getLanguage(lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = meta.rtl ? "rtl" : "ltr";
  }, [lang]);

  const setLang = useCallback((code) => {
    if (LANG_CODES.includes(code)) setLangState(code);
  }, []);

  const t = useCallback(
    (key) => (TABLES[lang] && TABLES[lang][key]) || UI.en[key] || key,
    [lang]
  );

  // Localized field picker: pick(obj, "title") -> obj.title_bn || obj.title_en
  const pick = useCallback(
    (obj, field) => {
      if (!obj) return "";
      return obj[`${field}_${lang}`] || obj[`${field}_en`] || obj[field] || "";
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, pick, meta: getLanguage(lang) }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
